import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Badge, Card, CardTitle } from "@/core/ui";
import { useSeasons } from "./api";

export function SeasonListPage() {
  const { t, i18n } = useTranslation();
  const seasons = useSeasons();
  if (seasons.isPending) return <p className="bt-page-message">{t("app.loading")}</p>;
  const items = seasons.data?.seasons ?? [];
  const date = (value: string) => new Date(value).toLocaleDateString(i18n.language);
  return (
    <section>
      <h1 className="bt-page-title">{t("seasons.title")}</h1>
      {items.length === 0 ? <p className="bt-page-message">{t("seasons.empty")}</p> : null}
      <ul className="bt-season-grid">
        {items.map((season) => (
          <li key={season.id}>
            <Link to={`/seasons/${season.id}`} className="bt-season-card-link">
              <Card className="bt-season-card">
                <div className="bt-season-card__header">
                  <CardTitle className="bt-card__title--flush">{season.name}</CardTitle>
                  <Badge tone="info">
                    {t(`seasons.scoring.${season.scoring}`, { defaultValue: season.scoring })}
                  </Badge>
                </div>
                <p className="bt-season-card__line">
                  {t("seasons.range", { from: date(season.starts_at), to: date(season.ends_at) })}
                </p>
                <p className="bt-season-card__line">
                  {t("seasons.puzzle_count", { count: season.puzzle_slugs.length })}
                </p>
              </Card>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
